module.exports = __webpack_public_path__ + "media/newstyle/images/ar_on_you-d1aacc33d7fd1f30b65d0b3ad1f5216a.svg";